(() => {
  const startedAt = Date.now();
  let customerChangedQuantity = false;
  let quantityToPreserve = 1;
  let preserveUntil = 0;
  let activeTable = null;
  let activeQuantityInput = null;
  let activePriceList = null;
  let activeSignature = '';
  let originalPriceHtml = '';
  let tiers = [];
  let showingDiscount = false;

  const toNumber = (text) => Number(String(text || '').replace(/[^0-9.-]/g, '')) || 0;
  const currency = window.Shopify?.currency?.active || 'CAD';
  const locale = document.documentElement.lang || 'en-CA';
  const money = (value) => new Intl.NumberFormat(locale, {
    style: 'currency',
    currency
  }).format(value);

  document.addEventListener('pointerdown', (event) => {
    if (!event.isTrusted) return;

    if (event.target.closest?.('quantity-selector, .cs_FD')) {
      customerChangedQuantity = true;
    }

    if (event.target.closest?.('.variant-picker__option-values label')) {
      const currentQuantity = document.querySelector('input[name="quantity"]');
      quantityToPreserve = Math.max(1, Number(currentQuantity?.value) || 1);
      preserveUntil = Date.now() + 3000;
    }
  }, true);

  const updatePrice = () => {
    if (!activeQuantityInput || !activePriceList || !tiers.length) return;

    const quantity = Math.max(1, Number(activeQuantityInput.value) || 1);
    const tier = tiers.filter((item) => quantity >= item.minimum).pop();

    if (!tier) {
      if (showingDiscount) activePriceList.innerHTML = originalPriceHtml;
      showingDiscount = false;
      return;
    }

    const discountedUnit = ((tier.unitPrice * quantity) - tier.discount) / quantity;
    activePriceList.innerHTML =
      '<compare-at-price class="text-subdued line-through">' +
        '<span class="sr-only">Regular price</span>' + money(tier.unitPrice) +
      '</compare-at-price>' +
      '<sale-price class="text-lg text-on-sale">' +
        '<span class="sr-only">Sale price</span>' + money(discountedUnit) +
      '</sale-price>';
    showingDiscount = true;
  };

  const connectCurrentFadTable = () => {
    const table = document.querySelector('.cs_FD');
    const quantityInput = document.querySelector('input[name="quantity"]');
    const priceList = document.querySelector('price-list.price-list--lg');
    const rows = table ? Array.from(table.querySelectorAll('.cs_FD_options[data-qty]')) : [];

    if (!table || !quantityInput || !priceList || !rows.length) return false;

    const signature = rows.map((row) => [
      row.dataset.qty,
      row.querySelector('.cs_FD_compare_price')?.textContent,
      row.querySelector('.cs_FD_regular_price')?.textContent
    ].join(':')).join('|');

    if (table !== activeTable || quantityInput !== activeQuantityInput || priceList !== activePriceList || signature !== activeSignature) {
      activeTable = table;
      activeQuantityInput = quantityInput;
      activePriceList = priceList;
      activeSignature = signature;
      originalPriceHtml = priceList.innerHTML;
      showingDiscount = false;

      tiers = rows.map((row) => {
        const minimum = Number(row.dataset.qty);
        const originalTotal = toNumber(row.querySelector('.cs_FD_compare_price')?.textContent);
        const discountedTotal = toNumber(row.querySelector('.cs_FD_regular_price')?.textContent);
        return {
          minimum,
          unitPrice: minimum ? originalTotal / minimum : 0,
          discount: originalTotal - discountedTotal
        };
      }).filter((tier) => tier.minimum > 0 && tier.unitPrice > 0 && tier.discount > 0)
        .sort((a, b) => a.minimum - b.minimum);

      quantityInput.addEventListener('input', updatePrice);
      quantityInput.addEventListener('change', updatePrice);
      table.addEventListener('click', () => setTimeout(updatePrice, 0));
      table.dataset.olivecPriceSync = 'true';
    }

    return tiers.length > 0;
  };

  setInterval(() => {
    if (!connectCurrentFadTable()) return;

    const keepInitialQuantity = !customerChangedQuantity && Date.now() - startedAt < 6000;
    const keepVariantQuantity = Date.now() < preserveUntil;
    const desiredQuantity = keepVariantQuantity ? quantityToPreserve : (keepInitialQuantity ? 1 : null);

    if (desiredQuantity !== null && Number(activeQuantityInput.value) !== desiredQuantity) {
      activeQuantityInput.value = String(desiredQuantity);
    }

    updatePrice();
  }, 250);
})();
